/**
 * StatusItem.jsx
 * Created by Destin Frasier on 12/06/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    status: PropTypes.string.isRequired,
    statusColor: PropTypes.string.isRequired
};

const StatusItem = ({ status, statusColor }) => (
    <span className="rec-status-indicator" key={status}>
        <span className={`rec-${statusColor}`} />{status}
    </span>
);

StatusItem.propTypes = propTypes;

export default StatusItem;